import { SET_CIRCUITO, SET_PASO, SET_PASO_ANTERIOR } from "../ActionTypes";

const paso = (state, { payload, type }) => {
  switch (type) {
    case SET_PASO:
      return {
        ...state,
        paso: {
          ...state.paso,
          data: payload,
        },
      };
    case SET_PASO_ANTERIOR:
      return {
        ...state,
        paso: {
          ...state.paso,
          anterior: payload,
        },
      };
    case SET_CIRCUITO:
      return {
        ...state,
        circuito: payload,
      };

    default:
      return state;
  }
};

export default paso;
